<template>
<div>
<ContentOverlay ></ContentOverlay>
<div class="content_card" v-if="item">





<div class="grid">
<!--sidebar-->
<ItemSidebar :name="$store.state.suppliers.supplier.name" 
:brand="$store.state.suppliers.supplier.brand"
>


<template #addition>


<div class="col-12 mb-2 py-0" >

<template v-if="item.status===0">
 <Button :label="$store.state.languages.lang_phrases.deaktif" class=" p-button-danger p-button-outlined w-full" :loading="$store.state.ui.submitting" type="button" @click="changeStatus(1)"></Button>
</template>
<template v-else>
<Button :label="$store.state.languages.lang_phrases.aktif" class=" p-button-success p-button-outlined w-full" :loading="$store.state.ui.submitting" type="button" ></Button>
</template>



</div>



 </template>



</ItemSidebar>
<!--sidebar-->





<div class="col-12 md:col-10">
<div class="content_card_content">

<TabNavigation :tabs="tabs"></TabNavigation>
<router-view></router-view>

</div>
</div>

</div>




</div>
<SupplierUploadDialog></SupplierUploadDialog>
 </div> 
</template>

<script>
export default {

  name: 'Section',

  data () {
    return {
      item:null,
      tabs: [
          {
              title: 'genel',
              icon: 'list',
              route: 'general',
          },
          {
              title: 'degiskenler',
              icon: 'lan',
              route: 'attributes',
              icon_type:'material'
          },
          {
            title: 'tedarikci_kartlari',
            icon: 'id-card',
            route:'supplier_cards'
          },
          {
              title: 'projeler',
              icon: 'calendar',
              route: 'projects',
          },         
          {
              title: 'yetkililer',
              icon: 'users',
              route: 'users',
          },       
          {
              title: 'tedarikci_gorusmeleri',
              icon: 'comment',
              route: 'conversations',
          },
      ],                 
      status_options:[
        {name:"planlama_bekliyor",id:"awaiting_schedule",color:"#352f8d"},
        {name:"planlandi",id:"scheduled",color:"#4dc247"},
        {name:"tamamlandi0",id:"completed",color:"#4dc247"},
        {name:"iptal_edildi",id:"deleted",color:"#a82400"},
      ],

    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',1) 
    this.getData()
    this.checkTabName(this.tabs)
  },
  computed:{
    is_active()
    {
      if(this.$store.state.suppliers.supplier)
      {
        if(this.$store.state.suppliers.supplier.status===0)
        {
          return "deactive"
        }
        else
        {
          return "active"
        }
      }
      return null
    }
  },
  methods:{
    changeStatus(data)
    {      
      let formdata = new FormData()
      formdata.append("status",data)
      this.generalSubmission(formdata,"supplier/update_status/"+this.$route.params.id,this.renewData)
    },
    async renewData()
    {
      this.item = await this.generalApiGetWithoutLoader("supplier/"+this.$route.params.id)
      this.$store.dispatch('verifications/setSupplier',this.item)
    },
    async getData()
    {
        this.item = await this.generalApiGet("supplier/"+this.$route.params.id)
        console.log(this.item)
        for(let tab of this.tabs)
        {
          tab.route =  "/"+this.$store.state.auth.user.uuid+"/supplier/"+this.$route.params.id+"/"+tab.route
        }
        await this.$store.dispatch('suppliers/setSupplier',this.item) 
        this.$store.dispatch
    }
  }
};
</script>

<style lang="css" scoped>
</style>